module.exports = __webpack_public_path__ + "img/mainPage_logo.0b7b0cf6.png";